export const FORMULARIO_VIAJE = {
    SELECCIONAR_RUTA: 57,
    INPUT_HORA_DE_PASO: 58,
    INPUT_KILOMETRO: 59,
    INPUT_TIEMPO_DESCANSO: 60,
    SELECCIONAR_REPORTAR_UBICACION: 61,
    INPUT_OBSERVACION: 62,
};